import { render } from "./GoalkeeperPrice.vue?vue&type=template&id=74e04250"
import script from "./GoalkeeperPrice.vue?vue&type=script&lang=js"
export * from "./GoalkeeperPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__